module.exports = __WEBPACK_EXTERNAL_MODULE_lRwf__;


//////////////////
// WEBPACK FOOTER
// external "vue"
// module id = lRwf
// module chunks = 7